// Modal.tsx
import React from "react";

interface ModalProps {
  isOpen: boolean;
  onSubscriptionDone: () => void;
}

const SubscriptionModal = ({ isOpen, onSubscriptionDone }: ModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center h-full bg-black bg-opacity-50 w-fill">
      <div className="items-center content-center w-1/2 p-4 mx-auto text-center bg-white rounded-lg shadow-lg h-1/2">
        <h2 className="text-lg font-bold">Sign up for Pro Subscription</h2>
        <button onClick={onSubscriptionDone} className="px-4 py-2 mt-4 text-white bg-green-500 rounded hover:bg-green-700">
          Done
        </button>
      </div>
    </div>
  );
};

export default SubscriptionModal;
